import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.5 5.5A1.5 1.5 0 0 0 16 4H7.334a2 2 0 0 0-1.988 1.782A57.583 57.583 0 0 0 5 12.035c-.001 2.077.11 4.138.335 6.183A2 2 0 0 0 7.323 20H16a1.5 1.5 0 0 0 1.5-1.5v-13Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.005 12.035a57.571 57.571 0 0 0-.346-6.253A2 2 0 0 0 16.671 4h-2.17A1.5 1.5 0 0 0 13 5.5v13a1.5 1.5 0 0 0 1.5 1.5h2.18a2 2 0 0 0 1.989-1.782c.224-2.045.336-4.106.335-6.183Z",
      clipRule: "evenodd"
    }
  )
);
var SvgControlStopFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ControlStopFilled_default = SvgControlStopFilled;

export { ControlStopFilled_default as default };
